var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutwhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_250_1",
    "data-name": "Component 250 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7707",
    "data-name": "Rectangle 7707",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15230",
    "data-name": "Group 15230",
    transform: "translate(-79.689 -262.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "log-in",
    transform: "translate(84 267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16253",
    "data-name": "Path 16253",
    d: "M15,3h3.427a1.714,1.714,0,0,1,1.714,1.714v12a1.714,1.714,0,0,1-1.714,1.714H15",
    transform: "translate(-4.763 -3)",
    fill: "none",
    stroke: "#810155",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16254",
    "data-name": "Path 16254",
    d: "M10,15.568l4.284-4.284L10,7",
    transform: "translate(-4.047 -3.573)",
    fill: "none",
    stroke: "#810155",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_920",
    "data-name": "Line 920",
    x1: 10,
    transform: "translate(-0.311 7.691)",
    fill: "none",
    stroke: "#810155",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutwhite);
export default __webpack_public_path__ + "static/media/Logoutwhite.65ae341b0959fceb1774450e66260599.svg";
export { ForwardRef as ReactComponent };